import { NEXT_PUBLIC_AUTH_SERVICE } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";

export default async function logoutAuthApi() {
  return await fetchUtil({
    url: `${NEXT_PUBLIC_AUTH_SERVICE}/logout`,
    method: "GET",
    body: {},
    useToken: true,
    credentials: "include",
    isExternalLogin: true,
    ctype: "",
  });
}
